import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AllFullClass;
function AllFull() {
  if (AllFullClass === VOID) {
    class $ {
      measure_gjrpfh_k$(layout, inProgress, within) {
        return within;
      }
      layout_cdpgg7_k$(layout, inProgress, within) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = layout.get_children_4cwbp4_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          inProgress.place_lp1sg6_k$(element, 0.0, 0.0, within.width_1, within.height_1);
        }
      }
    }
    initMetadataForObject($, 'AllFull');
    AllFullClass = $;
  }
  return AllFullClass;
}
var AllFull_instance;
function AllFull_getInstance() {
  return AllFull_instance;
}
//region block: init
AllFull_instance = new (AllFull())();
//endregion
//region block: exports
export {
  AllFull_instance as AllFull_instancentf5l2xyg2jp,
};
//endregion

//# sourceMappingURL=ProgrammaticLayout.mjs.map
